import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from '../OnlineBooking/OnlineBooking.module.scss';

export const BookingMore: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('booking');

  const {
    state: {
      settings: { onlineBooking, onlineBookingMultipleHost },
    },
    actions: { setSetting },
  } = useContext(SettingsContext);
  return (
    <Toggle
      label={t('setting.onlineBooking.multiple_hosts_2')}
      description={t('settings.smartGamer.booking.allow.description_2')}
      value={onlineBookingMultipleHost}
      className={s.multipleHost}
      onChange={(value: boolean) =>
        setSetting({
          alias: ESettingsAliases.ONLINE_BOOKING_MULTIPLE_HOST,
          value: value ? '1' : '0',
        })
      }
      variant="secondary"
      emptyBg
      disabled={!onlineBooking || !isAvailable}
    />
  );
};
